import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-flexbox-grid';
import { useQuery } from 'react-query';
import {
	Breadcrumb,
	BreadcrumbHome,
	BreadcrumbItem,
	SecondaryNavigation,
	SecondaryNavigationTitle,
	Wrapper,
} from '@wfp/ui';

import { useSectionId } from '../../hooks/section';
import { getSection } from '../../restapi/section';
import { HighlightsTitle, Topic } from '../../restapi/types';
import { SectionEdit } from './SectionEdit';
import { getDocByEdition } from '../../restapi/document';
import { LeftPanel } from './LeftPanel';
import { RightPanel } from './RightPanel';
import { OperationalUpdatesStateProvider } from './OperationalUpdatesStateProvider';
import { formatDate } from '../../utils';
import { SectionVersions } from './SectionVersions';


export function PageSection() {
	const secId = useSectionId();
	const secQuery = useQuery(['section', secId], () => getSection(secId));
	const s = secQuery.data;
	const docQuery = useQuery(['doc', 0, s?.edition], () => getDocByEdition(s!.edition), {
		enabled: !!s?.edition,  // The query will not execute until s.edition is known
	});
	const doc = docQuery.data;
	const docId = doc?.slug;
	const ed = doc?.editionSet.find(e => e.id === s?.edition);

	return (
		<div key={secId}>
			<SecondaryNavigation>
				<Breadcrumb>
					<BreadcrumbItem>
						<Link to="/">
							<BreadcrumbHome/>
						</Link>
					</BreadcrumbItem>
					{docId && <>
						<BreadcrumbItem>
							<Link to={`/${docId}`}>
								{formatDate(docId)}
							</Link>
						</BreadcrumbItem>
						<BreadcrumbItem disableLink> Edit section</BreadcrumbItem>
					</>
					}
				</Breadcrumb>
				{s ?
					<SecondaryNavigationTitle>{s.topic} - {s.topic === Topic.highlights ? HighlightsTitle : s.title}</SecondaryNavigationTitle>
					:
					<SecondaryNavigationTitle>...</SecondaryNavigationTitle>
				}
			</SecondaryNavigation>

			<OperationalUpdatesStateProvider>
				<Wrapper background="lighter" pageWidth="full" spacing="md">
					<Row>
						<Col className="col-fixed">
							{ed && s && <LeftPanel edition={ed}/>}
						</Col>
						<Col className="col-sm col-fill">
							{secQuery.data &&
							<div>
								<SectionEdit key={`${secQuery.data.id}-${secQuery.data.owner}`}
											 docId={docId}
											 section={secQuery.data}/>
								<SectionVersions section={secQuery.data}/>
							</div>
							}
						</Col>
						<Col className="col-fixed">
							{secQuery.data && <RightPanel/>}
						</Col>
					</Row>
				</Wrapper>
			</OperationalUpdatesStateProvider>
		</div>
	);
}
